import { fattribs, ff } from "./format";
export const ellipse = (p, rx, ry, attribs, ...body) => [
    "ellipse",
    fattribs(Object.assign(Object.assign({}, attribs), { cx: ff(p[0]), cy: ff(p[1]), rx: ff(rx), ry: ff(ry) })),
    ...body,
];
